<template>
    <div class="filters--text-search">
        <input id="text-search" v-on:keyup="change()" v-model="filterValue" type="text" placeholder="Filter by Keyword">
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
    name: 'TextSearch',
    data() {
      return {
        filterValue: '',
      }
    },
    methods: {
      change: _.debounce(function () {
        this.$emit("textSearch", this.filterValue)
      }, 500)
    },
  }
</script>
